import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DoctumentationLandingComponent } from './doctumentation-landing/doctumentation-landing.component';
import { PayGComponent } from './PAY_G/pay-g/pay-g.component';
import { PayGHindiComponent } from './PAY_G/pay-g-hindi/pay-g-hindi.component';
import { PaymentLinkComponent } from './Payment_Link/payment-link/payment-link.component';
import { PaymentLinkHindiComponent } from './Payment_Link/payment-link-hindi/payment-link-hindi.component';
import { CreateLinkComponent } from './Payment_Link/create-link/create-link.component';
import { CreateLinkHindiComponent } from './Payment_Link/create-link-hindi/create-link-hindi.component';
import { GStoreComponent } from './G-Store/g-store/g-store.component';
import { GStoreHindiComponent } from './G-Store/g-store-hindi/g-store-hindi.component';
import { PaymentQrComponent } from './Payment_QR/payment-qr/payment-qr.component';
import { PaymentQrHindiComponent } from './Payment_QR/payment-qr-hindi/payment-qr-hindi.component';
import { WebIntegrationComponent } from './Web_Integration/web-integration/web-integration.component';
import { WebIntegrationHindiComponent } from './Web_Integration/web-integration-hindi/web-integration-hindi.component';
import { PaymentGatewayComponent } from './Payment-Gateway/payment-gateway/payment-gateway.component';
import { PaymentGatewayHindiComponent } from './Payment-Gateway/payment-gateway-hindi/payment-gateway-hindi.component';
import { VideoKycComponent } from './Video_KYC/video-kyc/video-kyc.component';
import { VideoKycHindiComponent } from './Video_KYC/video-kyc-hindi/video-kyc-hindi.component';
import { TransactionComponent } from './Transactions/transaction/transaction.component';
import { TransactionHindiComponent } from './Transactions/transaction-hindi/transaction-hindi.component';
import { RefundsComponent } from './Refunds/refunds/refunds.component';
import { RefundsHindiComponent } from './Refunds/refunds-hindi/refunds-hindi.component';
import { InvoiceComponent } from './Invoice/invoice/invoice.component';
import { InvoiceHindiComponent } from './Invoice/invoice-hindi/invoice-hindi.component';
import { EAgreementComponent } from './E-Agreement/e-agreement/e-agreement.component';
import { EAgreementHindiComponent } from './E-Agreement/e-agreement-hindi/e-agreement-hindi.component';
import { DisputesComponent } from './Disputes/disputes/disputes.component';
import { DisputesHindiComponent } from './Disputes/disputes-hindi/disputes-hindi.component';
import { PayButtonComponent } from './Pay_Button/pay-button/pay-button.component';
import { PayButtonHindiComponent } from './Pay_Button/pay-button-hindi/pay-button-hindi.component';
import { PayProfileComponent } from './Pay_Profile/pay-profile/pay-profile.component';
import { PayProfileHindiComponent } from './Pay_Profile/pay-profile-hindi/pay-profile-hindi.component';
import { EasyCollectComponent } from './Pay_Profile/easy-collect/easy-collect.component';
import { EasyCollectHindiComponent } from './Pay_Profile/easy-collect-hindi/easy-collect-hindi.component';
import { SmartCollectComponent } from './Pay_Profile/smart-collect/smart-collect.component';
import { SmartCollectHindiComponent } from './Pay_Profile/smart-collect-hindi/smart-collect-hindi.component';
import { BookingComponent } from './Booking/booking/booking.component';
import { BookingHindiComponent } from './Booking/booking-hindi/booking-hindi.component';
import { CreatingProfileComponent } from './Booking/creating-profile/creating-profile.component';
import { CreatingProfileHindiComponent } from './Booking/creating-profile-hindi/creating-profile-hindi.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './Sidebar/sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { BookingTecketingComponent } from './Booking/booking-tecketing/booking-tecketing.component';
import { CreateProfileMainComponent } from './Booking/create-profile-main/create-profile-main.component';
import { DisputesMainComponent } from './Disputes/disputes-main/disputes-main.component';
import { AgreementComponent } from './E-Agreement/agreement/agreement.component';
import { StoreComponent } from './G-Store/store/store.component';
import { InvoiceMainComponent } from './Invoice/invoice-main/invoice-main.component';
import { ButtonsComponent } from './Pay_Button/buttons/buttons.component';
import { PaygMainComponent } from './PAY_G/payg-main/payg-main.component';
import { MainProfileComponent } from './Pay_Profile/main-profile/main-profile.component';
import { CollectsComponent } from './Pay_Profile/collects/collects.component';
import { SmartComponent } from './Pay_Profile/smart/smart.component';
import { MainLinksComponent } from './Payment_Link/main-links/main-links.component';
import { CreateMainComponent } from './Payment_Link/create-main/create-main.component';
import { PQRComponent } from './Payment_QR/p-qr/p-qr.component';
import { GatewayComponent } from './Payment-Gateway/gateway/gateway.component';
import { MainRefundsComponent } from './Refunds/main-refunds/main-refunds.component';
import { MainTransactionsComponent } from './Transactions/main-transactions/main-transactions.component';
import { KycComponent } from './Video_KYC/kyc/kyc.component';
import { IntegrationComponent } from './Web_Integration/integration/integration.component';
import { PayOutComponent } from './Payout/pay-out/pay-out.component';
import { OnbordingComponent } from './Onboarding/onbording/onbording.component';
import { FeaturesComponent } from './Payg_Features/features/features.component';
import { CouponsComponent } from './Coupons/coupons/coupons.component';
import { PriceComponent } from './Price_Match/price/price.component';
import { SettlementComponent } from './Settlement/settlement/settlement.component';
import { PriceMainComponent } from './Price_Match/price-main/price-main.component';
import { PriceHindiComponent } from './Price_Match/price-hindi/price-hindi.component';
import { PayoutMainComponent } from './Payout/payout-main/payout-main.component';
import { PayoutHindiComponent } from './Payout/payout-hindi/payout-hindi.component';
import {SettlementHindiComponent} from './Settlement/settlement-hindi/settlement-hindi.component';
import { SettlementMainComponent } from './Settlement/settlement-main/settlement-main.component';
import { OnboardingMainComponent } from './Onboarding/onboarding-main/onboarding-main.component';
import { OnboardingHindiComponent } from './Onboarding/onboarding-hindi/onboarding-hindi.component';
import { FeaturesMainComponent } from './Payg_Features/features-main/features-main.component';
import { FeaturesHindiComponent } from './Payg_Features/features-hindi/features-hindi.component';
import { CouponsMainComponent } from './Coupons/coupons-main/coupons-main.component';
import { CouponsHindiComponent } from './Coupons/coupons-hindi/coupons-hindi.component';
import { CreatePayoutComponent } from './Payout/create-payout/create-payout.component';
import { CreatePayoutMainComponent } from './Payout/create-payout-main/create-payout-main.component';
import { CreatePayoutHindiComponent } from './Payout/create-payout-hindi/create-payout-hindi.component';
import { ReportsComponent } from './Report/reports/reports.component';
import { ReportsMainComponent } from './Report/reports-main/reports-main.component';
import { ReportsHindiComponent } from './Report/reports-hindi/reports-hindi.component';
import { MerchantComponent } from './Merchant-Dashboard/merchant/merchant.component';
import { MerchnatMainComponent } from './Merchant-Dashboard/merchnat-main/merchnat-main.component';
import { MerchantHindiComponent } from './Merchant-Dashboard/merchant-hindi/merchant-hindi.component';
import { ShareButtonComponent } from './share-button/share-button.component';
import { ClipboardModule } from 'ngx-clipboard';
import { PaymentGatewayWorkingComponent } from './Payment-Gateway/payment-gateway-working/payment-gateway-working.component';
import { PaymentGatewayWorkingHindiComponent } from './Payment-Gateway/payment-gateway-working-hindi/payment-gateway-working-hindi.component';
import { PaymentGatewayWorkingEnglishComponent } from './Payment-Gateway/payment-gateway-working-english/payment-gateway-working-english.component';
import { IntroductionResellerComponent } from './Reseller/Reseller-intro/introduction-reseller/introduction-reseller.component';
import { RegistrationProcessComponent } from './Reseller/Registration-process/registration-process/registration-process.component';
import { LoginWithQrComponent } from './Reseller/login-with-QR/login-with-qr/login-with-qr.component';
import { ManualLoginComponent } from './Reseller/Manual-Login-Process/manual-login/manual-login.component';
import { ResellerIntroHindiComponent } from './Reseller/reseller-intro-hindi/reseller-intro-hindi.component';
import { ResellerIntroMainComponent } from './Reseller/reseller-intro-main/reseller-intro-main.component';
import { RegistrationProcessHindiComponent } from './Reseller/registration-process-hindi/registration-process-hindi.component';
import { RegistrationProcessMainComponent } from './Reseller/registration-process-main/registration-process-main.component';
import { ManualLoginHindiComponent } from './Reseller/manual-login-hindi/manual-login-hindi.component';
import { ManualLoginMainComponent } from './Reseller/manual-login-main/manual-login-main.component';
import { LoginWithQrHindiComponent } from './Reseller/login-with-qr-hindi/login-with-qr-hindi.component';
import { LoginWithQrMainComponent } from './Reseller/login-with-qr-main/login-with-qr-main.component';

@NgModule({
  declarations: [
    AppComponent,
    
    DoctumentationLandingComponent,

    PayGComponent,
    PayGHindiComponent,
    PaymentLinkComponent,
    PaymentLinkHindiComponent,
    CreateLinkComponent,
    CreateLinkHindiComponent,
    GStoreComponent,
    GStoreHindiComponent,
    PaymentQrComponent,
    PaymentQrHindiComponent,
    WebIntegrationComponent,
    WebIntegrationHindiComponent,
    PaymentGatewayComponent,
    PaymentGatewayHindiComponent,
    VideoKycComponent,
    VideoKycHindiComponent,
    TransactionComponent,
    TransactionHindiComponent,
    RefundsComponent,
    RefundsHindiComponent,
    InvoiceComponent,
    InvoiceHindiComponent,
    EAgreementComponent,
    EAgreementHindiComponent,
    DisputesComponent,
    DisputesHindiComponent,
    PayButtonComponent,
    PayButtonHindiComponent,
    PayProfileComponent,
    PayProfileHindiComponent,
    EasyCollectComponent,
    EasyCollectHindiComponent,
    SmartCollectComponent,
    SmartCollectHindiComponent,
    BookingComponent,
    BookingHindiComponent,
    CreatingProfileComponent,
    CreatingProfileHindiComponent,
    FooterComponent,
    SidebarComponent,
    HeaderComponent,
    BookingTecketingComponent,
    CreateProfileMainComponent,
    DisputesMainComponent,
    AgreementComponent,
    StoreComponent,
    InvoiceMainComponent,
    ButtonsComponent,
    PaygMainComponent,
    MainProfileComponent,
    CollectsComponent,
    SmartComponent,
    MainLinksComponent,
    CreateMainComponent,
    PQRComponent,
    GatewayComponent,
    MainRefundsComponent,
    MainTransactionsComponent,
    KycComponent,
    IntegrationComponent,
    PayOutComponent,
    OnbordingComponent,
    FeaturesComponent,
    CouponsComponent,
    PriceComponent,
    SettlementComponent,
    PriceMainComponent,
    PriceHindiComponent,
    PayoutMainComponent,
    PayoutHindiComponent,
    SettlementHindiComponent,
    SettlementMainComponent,
    PriceMainComponent,
    OnboardingMainComponent,
    OnboardingHindiComponent,
    FeaturesMainComponent,
    FeaturesHindiComponent,
    CouponsMainComponent,
    CouponsHindiComponent,
    CreatePayoutComponent,
    CreatePayoutMainComponent,
    CreatePayoutHindiComponent,
    ReportsComponent,
    ReportsMainComponent,
    ReportsHindiComponent,
    MerchantComponent,
    MerchnatMainComponent,
    MerchantHindiComponent,
    ShareButtonComponent,
    PaymentGatewayWorkingComponent,
    PaymentGatewayWorkingHindiComponent,
    PaymentGatewayWorkingEnglishComponent,
    IntroductionResellerComponent,
    RegistrationProcessComponent,
    LoginWithQrComponent,
    ManualLoginComponent,
    ResellerIntroHindiComponent,
    ResellerIntroMainComponent,
    RegistrationProcessHindiComponent,
    RegistrationProcessMainComponent,
    ManualLoginHindiComponent,
    ManualLoginMainComponent,
    LoginWithQrHindiComponent,
    LoginWithQrMainComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
      FormsModule,
      CommonModule ,ClipboardModule,
      
    ReactiveFormsModule
    
  ],
  
  providers: [
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpErrorInterceptor,
    //   multi: true
    // },
     { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
